import { Typography } from '@mui/material';
import React, { ReactElement, FC } from 'react';
import { ICalculation } from '../Interface/Interface';
import { useAppSelector } from '../hooks';
import { t } from 'react-i18nify';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
  return {
    container: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      paddingBottom: 0,
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'end'
      },
      [theme.breakpoints.up('sm')]: {
        paddingBottom: 16
      }
    }
  };
});

const PriceBox: FC = (): ReactElement => {
  const { classes } = useStyles();

  const calculation: ICalculation | undefined = useAppSelector(
    (state) => state.configuration.calculation
  );
  let price = '';
  let priceHint = '';
  if (calculation) {
    const query = new URLSearchParams(location.search);
    if (
      query.has('_display_net_prices') &&
      query.get('_display_net_prices') === '1'
    ) {
      price = calculation.netTotalFormatted;
      priceHint = t('netPriceHint');
    } else {
      price = calculation.totalFormatted;
      priceHint = t('priceHint');
    }
  }

  return (
    <div className={classes.container}>
      <Typography
        sx={{ fontWeight: 'bold', fontSize: '18px' }}
        variant="h3"
        align="right">
        {price}
      </Typography>
      <Typography sx={{ fontSize: '10px' }} align="right">
        {priceHint}
      </Typography>
    </div>
  );
};

export default PriceBox;
